/**
 * App
 */
export * from './app.module';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/index.ts